export default __webpack_public_path__ + "static/media/Iconsarrow.a091dba7.svg";